import React from "react";
import currency from "currency.js";
import { CurrencyInputProps } from ".";
import { Input } from "..";

export const CurrencyInput: React.FunctionComponent<CurrencyInputProps> = ({
  value,
  onChange,
  placeholder,
  error,
}) => (
  <div className="flex flex-row justify-between items-center">
    <div
      className={`input-group border border-${
        error ? "danger" : "grey"
      } rounded`}
      style={{ flex: 2 }}
    >
      <div className="input-group-prepend w-25 pr-0 border-0">
        <span className="input-group-text bg-white border-0 pr-0 text-secondary-gray pl-2">
          Rp
        </span>
      </div>
      <Input
        placeholder={placeholder}
        className="w-75"
        inputClassName="border-0 ml-0 pl-2 py-2"
        value={
          value
            ? currency(value, {
                separator: ".",
                precision: 0,
                symbol: "",
              }).format()
            : ""
        }
        style={{ flex: 1 }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event?.target?.value)
        }
      />
    </div>
  </div>
);
